import { LoggedInUser } from '../types';

export const isUserAnAdmin = (user: LoggedInUser): boolean =>
	user && user.role === 'admin';
